function base64UrlToBuffer(base64url: string): ArrayBuffer {
  if (!base64url) return new ArrayBuffer(0)
  const padding = '='.repeat((4 - (base64url.length % 4)) % 4)
  const base64 = (base64url + padding).replace(/-/g, '+').replace(/_/g, '/')
  const rawData = window.atob(base64)
  const buffer = new ArrayBuffer(rawData.length)
  const uintArray = new Uint8Array(buffer)
  for (let i = 0; i < rawData.length; i++) uintArray[i] = rawData.charCodeAt(i)
  return buffer
}

export function bufferToBase64Url(buffer: ArrayBuffer): string {
  if (!buffer) return ''
  const uintArray = new Uint8Array(buffer)
  let binary = ''
  for (let i = 0; i < uintArray.byteLength; i++) binary += String.fromCharCode(uintArray[i])
  return window.btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '')
}

export function prepareCredentialCreationOptions(payload: unknown): PublicKeyCredentialCreationOptions {
  const data = payload as Record<string, unknown>
  const options =
    (data?.publicKey as Record<string, unknown>) ||
    (data?.PublicKey as Record<string, unknown>) ||
    (data?.options as Record<string, unknown>)?.publicKey ||
    data?.options ||
    data
  if (!options || typeof options !== 'object') {
    throw new Error('无法从服务端响应中解析 Passkey 注册参数')
  }
  const opts = options as {
    challenge: string
    user: { id: string; name?: string; displayName?: string }
    excludeCredentials?: Array<{ id: string; type: string; transports?: string[] }>
    attestationFormats?: string[]
    [k: string]: unknown
  }
  const publicKey = {
    ...(opts as unknown as PublicKeyCredentialCreationOptions),
    challenge: base64UrlToBuffer(opts.challenge),
    user: {
      ...opts.user,
      id: base64UrlToBuffer(opts.user.id),
    } as PublicKeyCredentialUserEntity,
  } as PublicKeyCredentialCreationOptions
  if (Array.isArray(opts.excludeCredentials)) {
    publicKey.excludeCredentials = opts.excludeCredentials.map((item) => ({
      ...item,
      id: base64UrlToBuffer(item.id),
    })) as PublicKeyCredentialDescriptor[]
  }
  if (Array.isArray(opts.attestationFormats) && opts.attestationFormats.length === 0) {
    delete (publicKey as { attestationFormats?: string[] }).attestationFormats
  }
  return publicKey
}

export function buildRegistrationResult(credential: PublicKeyCredential) {
  const response = credential.response as AuthenticatorAttestationResponse
  const transports =
    typeof response.getTransports === 'function' ? response.getTransports() : undefined
  return {
    id: credential.id,
    rawId: bufferToBase64Url(credential.rawId),
    type: credential.type,
    authenticatorAttachment: credential.authenticatorAttachment,
    response: {
      attestationObject: bufferToBase64Url(response.attestationObject),
      clientDataJSON: bufferToBase64Url(response.clientDataJSON),
      transports,
    },
    clientExtensionResults: credential.getClientExtensionResults?.() ?? {},
  }
}

export function isPasskeySupported(): boolean {
  return (
    typeof window !== 'undefined' &&
    typeof window.PublicKeyCredential !== 'undefined' &&
    typeof navigator !== 'undefined' &&
    !!navigator.credentials
  )
}
